import Cookie from 'utils/cookies';
import reducerRegistry from '../../../reduxUtils/reducerRegistry';
import makeRequest from '../../../utils/makeRequest';
import { ABOUND_BACKEND_SERVICE_DOMAIN } from '../../../constants';

const reducerName = 'abound';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const LOGIN_POINTS_RECEIVED = createActionName('LOGIN_POINTS_RECEIVED');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');

export const DATA_LOADING = createActionName('DATA_LOADING');

export const DATA_LOADED = createActionName('DATA_LOADED');

function receiveAboundData(data) {
  return {
    type: LOGIN_POINTS_RECEIVED,
    payload: data,
  };
}

export function handleDataError(data = null) {
  return {
    type: HANDLE_DATA_ERROR,
    payload: {
      data,
    },
  };
}

export function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

export function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

async function aboundSignUp({ ssoid, phoneNumber }) {
  const ssoId = ssoid || Cookie.get('ssoid') || Cookie.get('ssoId');
  const response = await makeRequest.post(
    `${ABOUND_BACKEND_SERVICE_DOMAIN}/ufs-utility/api/v1/abound/signup?ssoid=${ssoId}`,
    {
      mobileNumber: phoneNumber,
    },
  );
  return response;
}

export function loadLoginAboundPoints({ ssoid, phoneNumber }) {
  return dispatch => {
    dispatch(dataLoading());
    aboundSignUp({ ssoid, phoneNumber })
      .then(response => {
        dispatch(dataLoaded());
        dispatch(receiveAboundData(response.data));
        dispatch(handleDataError());
      })
      .catch(error => {
        dispatch(dataLoaded());
        dispatch(
          handleDataError(
            error?.response?.data?.message || error?.response?.data,
          ),
        );
      });
  };
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    case HANDLE_DATA_ERROR: {
      return {
        ...state,
        error: action.payload.data,
      };
    }
    case LOGIN_POINTS_RECEIVED:
      Cookie.set('aboundToken', action.payload?.clientToken);
      return {
        ...state,
        userData: action.payload,
      };
    default:
      return state;
  }
}
reducerRegistry.register(reducerName, reducer);
